import * as components from "./components";
import * as AureaComponents from "./components/aurea";
import "@mdi/font/css/materialdesignicons.css";
import "roboto-fontface/css/roboto/roboto-fontface.css";


import {Pagination} from "./components/TecnaLazyCombobox/TcnlazyCombobox";
import TcnVJsfWrapper from "./components/TecnaForm/TcnVJsfWrapper";
import moment from "moment"

const TecnaVueShared = {
    install(Vue, options) {
        if (options !== undefined && "moment" in options) {
            Vue.prototype.$moment = options.moment;
        } else {
            Vue.prototype.$moment = moment
        }

        //zagnieżdzenie wrapera w template wymagało globalnego importu bo nie wykrywało komponentu
        Vue.component("TcnVJsfWrapper", TcnVJsfWrapper);
        for (const componentName in components) {
            const component = components[componentName];

            Vue.component(component.name, component);
        }
    },
};

export default TecnaVueShared;

const AureaVueShared = {
    install(Vue) {
        for (const componentName in AureaComponents) {
            const component = AureaComponents[componentName];

            Vue.component(component.name, component);
        }
    },
};

export {AureaVueShared, Pagination};

if (typeof window !== "undefined" && window.Vue) {
    window.Vue.use(TecnaVueShared);
}
